import * as React from 'react';

import { SmallButton } from '~shared/components/buttons';

import { GenerationType } from './GenerateQuestionsDialog';
import { GenerateQuestionDialogContent } from './Layout/GenerateQuestionDialogContent';

interface SelectGenerationTypeProps {
  setGenerationType: (newSelectedType: GenerationType) => void;
}

export function SelectGenerationType({
  setGenerationType,
}: SelectGenerationTypeProps) {
  return (
    <GenerateQuestionDialogContent
      header={
        <GenerateQuestionDialogContent.Header>
          Generate retake or practice assessments to strengthen understanding.
        </GenerateQuestionDialogContent.Header>
      }
    >
      <div className="flex flex-col gap-2">
        <SmallButton onClick={() => setGenerationType('areas-of-improvement')}>
          Areas of Improvement
        </SmallButton>
        <SmallButton onClick={() => setGenerationType('specific-students')}>
          Specific Students
        </SmallButton>
      </div>
    </GenerateQuestionDialogContent>
  );
}
